<template>
  <div>
    <el-dialog
      title="编辑模板"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="800px"
      @close="close"
      v-dialogDrag
    >
      <el-form
        :model="dataObj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="110px"
      >
        <el-form-item label="模板标题" prop="name">
          <el-input
            v-model="dataObj.name"
            placeholder="请输入"
            class="input-width-two"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否公开" prop="isOpen">
          <el-radio-group v-model="dataObj.isOpen">
            <el-radio :label="1">否</el-radio>
            <el-radio :label="0">是</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模板语种">
          <el-select
            class="input-width-two"
            v-model="dataObj.templateLanguages"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(val, key, index) in dropList.templateLanguages"
              :label="val"
              :value="key * 1"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板类型">
          <el-select
            class="input-width-two"
            v-model="dataObj.templateType"
            clearable
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="(val, key, index) in dropList.templateType"
              :label="val"
              :value="key *1"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模板内容" prop="content">
          <el-input
           :rows="6"
            v-model="dataObj.content"
            placeholder="请输入"
            type="textarea"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogFormVisible = false"
          v-preventReClick="5000"
          :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkEdit('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 编辑邮件模板弹窗
 * 功能：回填并修改标题、公开状态、语种、类型、内容后提交
 */
import { templateEdit } from "@/api/user";
import { getTemplateRules } from "@/utils/tabelRules";
export default {
  name: "edit",
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dropList: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      rules: {},
      // 表单数据（标题、公开状态、内容、id、语种、类型）
      dataObj: {
        isOpen: "",
        name: "",
        content: "",
        id: "",
        templateLanguages: "",
        templateType: "",
      },
      disabled: false,
      // 弹窗显隐
      dialogFormVisible: true,
    };
  },
  /** 组件创建后回填表单数据 */
  created() {
    this.handleClick();
  },
  methods: {
    /** 回填表单数据并加载校验规则，语种/类型为 0 时置空避免下拉显示异常 */
    handleClick() {
      Object.assign(this.dataObj, this.scope);
      Object.assign(this.rules, getTemplateRules());
      this.dataObj.templateLanguages=this.dataObj.templateLanguages===0?'':this.dataObj.templateLanguages
      this.dataObj.templateType=this.dataObj.templateType===0?'':this.dataObj.templateType
    },
    /** 关闭弹窗并通知父组件刷新列表 */
    close() {
      this.$emit("getList");
      this.$emit("isShowEdit");
    },
    /** 表单校验通过后提交修改 */
    checkEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          templateEdit(this.dataObj).then((result) => {
            if (result.code == 200) {
              this.$message({
                message: result.msg,
                type: "success",
              });
              this.$emit("getList");
              this.$emit("isShowEdit");
            }
          });
        }
      });
    },
  },
};
</script>